angular.module('bmsApp.settings').factory('TaxCodeSvc', function ($http, $log, $window, $q, CRUDSvc, TAX_CODE_API) {

	return {
		index: function (params) {
			return CRUDSvc.get(TAX_CODE_API.INDEX, params);
		}
	}

}).constant('TAX_CODE_API', {
	INDEX: 'api/settings/taxCodes/index'
});

